<form #form="ngForm" class="container-form" novalidate>
    <!--Options-->
    <div class="row container-form-options">
        <div class="col-12">
            <button type="button" class="btn btn-success mr-2" (click)="save()" id="btnSave">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
                <button type="button" class="btn btn-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-content" *ngIf="entity">
        <div class="col-12">
            <div class="row">
                <div class="form-group col-12 col-md-3">
                    <label for="codigoIntegracaoErp" class="col-form-label">Código ERP</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.codigoIntegracaoErp" id="codigoIntegracaoErp" name="codigoIntegracaoErp"
                        #codigoIntegracaoErp="ngModel" required="required" [autofocus]="true">
                    <p style="margin-bottom:0px;" class="form-text text-muted">Código da classificação no seu sistema ERP</p>
                    <sgt-form-control-error
                        *ngIf="codigoIntegracaoErp.errors && codigoIntegracaoErp.errors.required && codigoIntegracaoErp.dirty"
                        msgError="O código ERP é obrigatório">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="nome" class="col-form-label">Nome</label>
                    <input type="text" class="form-control " [(ngModel)]="entity.nome" name="nome" id="nome"
                        #nome="ngModel" required="required" maxlength="255">
                    <sgt-form-control-error
                        *ngIf="nome.errors && nome.errors.required && nome.dirty"
                        msgError="O nome é obrigatório">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="nome.errors && nome.errors.maxlength"
                        msgError="O nome deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>

            <sgt-info-group title="Faturamento Mensal"></sgt-info-group>
            <div class="row">
                <div class="form-group col-12 col-md col-lg-4">
                    <label for="valorFaturamentoMensalInicial" class="col-form-label">Valor Inicial</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">R$</span>
                        </div>                        
                        <sgt-decimal [(ngModel)]="entity.valorFaturamentoMensalInicial" (ngModelChange)="onChangeValorFaturamentoMensalInicial()" name="valorFaturamentoMensalInicial" id="valorFaturamentoMensalInicial"
                            #valorFaturamentoMensalInicial="ngModel" #valorFaturamentoMensalInicialDecimal [ngControl]="valorFaturamentoMensalInicial">
                        </sgt-decimal>                    
                    </div>
                    <sgt-form-control-error
                        *ngIf="valorFaturamentoMensalInicial.errors && valorFaturamentoMensalInicial.errors.required && valorFaturamentoMensalInicial.dirty"
                        msgError="O valor inicial é obrigatório quando informado o valor final">
                    </sgt-form-control-error>                    
                </div>
                <div class="form-group col-12 col-md col-lg-4">
                    <label for="valorFaturamentoMensalFinal" class="col-form-label">Valor Final</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">R$</span>
                        </div>                        
                        <sgt-decimal [(ngModel)]="entity.valorFaturamentoMensalFinal" (ngModelChange)="onChangeValorFaturamentoMensalFinal()" name="valorFaturamentoMensalFinal" id="valorFaturamentoMensalFinal"
                            #valorFaturamentoMensalFinal="ngModel" #valorFaturamentoMensalFinalDecimal [ngControl]="valorFaturamentoMensalFinal">
                        </sgt-decimal>                    
                    </div>
                    <p class="form-text text-muted">Deixe em branco quando não tiver limite de valor</p>                    
                </div>                
            </div>

            <sgt-info-group title="Faturamento Anual"></sgt-info-group>
            <div class="row">
                <div class="form-group col-12 col-md col-lg-4">
                    <label for="valorFaturamentoAnualInicial" class="col-form-label">Valor Inicial</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">R$</span>
                        </div>                        
                        <sgt-decimal [(ngModel)]="entity.valorFaturamentoAnualInicial" (ngModelChange)="onChangeValorFaturamentoAnualInicial()" name="valorFaturamentoAnualInicial" id="valorFaturamentoAnualInicial"
                            #valorFaturamentoAnualInicial="ngModel" #valorFaturamentoAnualInicialDecimal [ngControl]="valorFaturamentoAnualInicial"
                            >
                        </sgt-decimal>                    
                    </div>
                    <sgt-form-control-error
                        *ngIf="valorFaturamentoAnualInicial.errors && valorFaturamentoAnualInicial.errors.required && valorFaturamentoAnualInicial.dirty"
                        msgError="O valor inicial é obrigatório quando informado o valor final">
                    </sgt-form-control-error>                    
                </div>
                <div class="form-group col-12 col-md col-lg-4">
                    <label for="valorFaturamentoAnualFinal" class="col-form-label">Valor Final</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">R$</span>
                        </div>                        
                        <sgt-decimal [(ngModel)]="entity.valorFaturamentoAnualFinal" (ngModelChange)="onChangeValorFaturamentoAnualFinal()" name="valorFaturamentoAnualFinal" id="valorFaturamentoAnualFinal"
                            #valorFaturamentoAnualFinal="ngModel" #valorFaturamentoAnualFinalDecimal [ngControl]="valorFaturamentoAnualFinal">
                        </sgt-decimal>                    
                    </div>
                    <p class="form-text text-muted">Deixe em branco quando não tiver limite de valor</p>                    
                </div>                
            </div>

            <sgt-info-group title="Configurações"></sgt-info-group>
            <div class="row">
                <div class="form-group col-12 col-lg-4">
                    <label for="valorPadraoRAP" class="col-form-label">Valor Padrão {{KPI_RAP.sigla}}</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">R$</span>
                        </div>                        
                        <sgt-decimal [(ngModel)]="entity.valorPadraoRAP" name="valorPadraoRAP" id="valorPadraoRAP"
                            #valorPadraoRAP="ngModel" #valorPadraoRAPDecimal [ngControl]="valorPadraoRAP">
                        </sgt-decimal>                    
                    </div>
                    <p class="form-text text-muted">Valor Padrão do {{KPI_RAP.sigla}} ({{KPI_RAP.nome}})</p>                    
                </div>
            </div>
        </div>
    </div>
</form>
